import React from 'react';
import { Flame, Check, BookOpenCheck } from 'lucide-react';

const message = ({ thisWeek, dayCount, streak }) => {
  if (thisWeek === 0) return "Start with today's reading — every day you read is one small step closer.";
  if (thisWeek >= dayCount) return "You've read every day this week. Beautifully done!";
  if (streak >= 3) return `You've read ${thisWeek} of ${dayCount} days this week — a ${streak}-day streak. Keep going!`;
  return `You've read ${thisWeek} of ${dayCount} days this week. Nice and steady.`;
};

export const ReadingStreak = ({ stats, days, isRead, todayNum }) => (
  <div className="rounded-2xl border border-green-100 bg-green-50/70 p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="reading-streak">
    <div className="flex items-center gap-3 shrink-0">
      <div className={`w-11 h-11 rounded-full flex items-center justify-center ${stats.streak >= 2 ? 'bg-amber-100 text-amber-600' : 'bg-white text-church-green'}`}>
        {stats.streak >= 2 ? <Flame className="w-6 h-6" /> : <BookOpenCheck className="w-6 h-6" />}
      </div>
      <div>
        <p className="text-sm font-semibold text-slate-900" data-testid="reading-streak-count">
          {stats.thisWeek} of {stats.dayCount} days read
        </p>
        <p className="text-xs text-slate-500" data-testid="reading-streak-days">
          {stats.streak >= 2 ? `${stats.streak}-day streak` : 'Read today to start a streak'}
        </p>
      </div>
    </div>
    <p className="text-sm text-slate-700 flex-1" data-testid="reading-streak-message">{message(stats)}</p>
    <div className="flex items-center gap-1.5" aria-label="Days read" data-testid="reading-streak-dots">
      {days.map((d) => {
        const read = isRead(d.day_number);
        return (
          <span
            key={d.day_number}
            title={`Day ${d.day_number}${read ? ' · read' : ''}`}
            className={`w-7 h-7 rounded-full text-[11px] font-semibold flex items-center justify-center border transition-colors ${
              read ? 'bg-church-green border-church-green text-white' : d.day_number === todayNum ? 'border-church-green text-church-green bg-white' : 'border-slate-200 text-slate-400 bg-white'
            }`}
            data-testid={`reading-dot-${d.day_number}`}
            data-read={read ? 'true' : 'false'}
          >
            {read ? <Check className="w-3.5 h-3.5" /> : d.day_number}
          </span>
        );
      })}
    </div>
  </div>
);
